import { css } from '@compiled/react';

import { token } from '@atlaskit/tokens';

import { Expand } from '@/libraries/design/components/expand/src/expand.tsx';
import { Link } from '@/libraries/design/components/link/src/link.tsx';
import { Lozenge } from '@/libraries/design/components/lozenge/src/lozenge.tsx';

import { Checkmark } from './checkmark.tsx';
import { TextContent } from './text-content.tsx';
import {
	CellExpanderContentData,
	CellHyperlinkContentData,
	CellRenderContentData,
	CellTextContentData,
} from './types.ts';

export interface CellTextContentProps {
	data: CellTextContentData;
	isRowHeader?: boolean;
}
export const CellTextContent = (props: CellTextContentProps) => {
	const { data, isRowHeader } = props;
	return (
		<div
			css={[
				css({
					display: 'flex',
					gap: token('space.100'),
				}),
				isRowHeader &&
					css({
						paddingInlineStart: '30px',
					}),
			]}
		>
			{data.check && !isRowHeader && <Checkmark />}
			<span css={[data.check && css({ paddingBlockStart: '2.5px' })]}>
				<TextContent data={data.value} />
			</span>
			{data.lozenge && (
				<span>
					<Lozenge text={data.lozenge} />
				</span>
			)}
		</div>
	);
};

export const CellCheckContent = () => {
	return <Checkmark />;
};
export interface CellExpanderContentProps {
	data: CellExpanderContentData;
}
export const CellExpanderContent = (props: CellExpanderContentProps) => {
	const { data } = props;

	const label = data.lozenge ? (
		<span>
			{data.label} <Lozenge text={data.lozenge} />
		</span>
	) : (
		data.label
	);

	return (
		<Expand label={label}>
			<TextContent data={data.body} />
		</Expand>
	);
};

export interface CellHyperlinkContentProps {
	data: CellHyperlinkContentData;
}
export const CellHyperlinkContent = (props: CellHyperlinkContentProps) => {
	return (
		<Link
			// id={rowDescId} // todo
			css={css({
				fontSize: '14px',
				marginInlineStart: '4px',
			})}
			text={props.data.label}
			href={props.data.href}
			type={'primary'}
			aria-label={props.data.label}
			ariaLabel={props.data.label}
			dataEventProps={props.data.dataEventProps}
		/>
	);
};

export interface CellRenderContentProps {
	data: CellRenderContentData;
}
export const CellRenderContent = (props: CellRenderContentProps) => {
	return <span>{props.data.render()}</span>;
};
